module.exports = __webpack_public_path__ + "img/thumbnail_Binturong_f_normal.76f7182f.png";